<template>
  <div class="name-container" :style="{ fontSize: fontSize }">
    <div ref="origTextContainer" class="orig-text-container">{{ text }}</div>
    <div ref="cloneAnimContainer" class="clone-anim-container"></div>
    <div v-if="!isOneLine" ref="cloneContainer" class="clone-container"></div>
  </div>
</template>

<script>
import SplitText from '@/assets/gsap-bonus/SplitText'

export default {
  name: 'NameContainer',

  props: {
    text: {
      type: String,
      required: true
    },
    useSplitText: {
      type: Boolean,
      defaut: false
    },
    isOneLine: {
      type: Boolean,
      defaut: false
    },
    charsLimitOne: {
      type: Number,
      default: 9
    },
    charsLimitTwo: {
      type: Number,
      default: 11
    },
    charsLimitThree: {
      type: Number,
      default: 15
    },

    sizeOne: {
      type: String,
      default: '0.8em'
    },
    sizeTwo: {
      type: String,
      default: '0.7em'
    },
    sizeThree: {
      type: String,
      default: '0.5em'
    }
  },

  data () {
    return {
      longestLine: 0,
      isTextChanged: false
    }
  },

  computed: {
    cloneAnimContainer () { return (this.$refs && this.$refs.cloneAnimContainer) ? this.$refs.cloneAnimContainer : null },
    origTextContainer () { return (this.$refs && this.$refs.origTextContainer) ? this.$refs.origTextContainer : null },
    cloneContainer () { return (this.$refs && this.$refs.cloneContainer) ? this.$refs.cloneContainer : null },

    fontSize () {
      return (this.longestLine >= this.charsLimitOne)
        ? (this.longestLine >= this.charsLimitTwo)
          ? (this.longestLine >= this.charsLimitThree)
            ? this.sizeThree
            : this.sizeTwo
          : this.sizeOne
        : 'inherit'
    }
  },

  watch: {
    text () {
      this.isTextChanged = true
    }
  },

  mounted () {
    // Get clone container
    this.updateAnimClone()
    this.adjustText()
  },

  updated () {
    if (this.isTextChanged) {
      this.isTextChanged = false
      this.longestLine = 0
      this.adjustText()
    }
  },

  methods: {
    adjustText () {
      if (!this.isOneLine) {
        this.updateClone()
        this.getLongestLine()
        // Second round of adjustments for good measure
        this.updateClone()
        this.getLongestLine()
      } else {
        this.getCharCount()
      }
      this.updateAnimClone()
    },

    updateAnimClone () {
      if (this.cloneAnimContainer && this.origTextContainer) {
        // Clone the node so SplitText doesn't modify the reactive element
        const textEl = this.origTextContainer.cloneNode(true)

        // Replace clone content with new clone
        this.cloneAnimContainer.innerHTML = textEl.innerHTML

        // Use SplitText on clone and apply classes for animation
        if (this.useSplitText) {
          // eslint-disable-next-line no-new
          new SplitText(this.cloneAnimContainer, {
            linesClass: 'split-line',
            charsClass: 'split-char'
          })
        }
      }
    },

    updateClone () {
      if (this.cloneContainer && this.origTextContainer) {
        // Clone the node so SplitText doesn't modify the reactive element
        const textEl = this.origTextContainer.cloneNode(true)

        // Replace clone content with new clone
        this.cloneContainer.innerHTML = textEl.innerHTML
      }
    },

    getLongestLine () {
      if (this.$el && this.cloneContainer) {
        const textElSplit = new SplitText(this.cloneContainer, { type: 'lines' })
        this.longestLine = textElSplit.lines.reduce(
          (longest, item) => {
            return longest < item.innerText.length ? item.innerText.length : longest
          }, 0)
      }
    },

    getCharCount () {
      this.longestLine = this.text.length
    }
  }
}
</script>

<style scoped>
.name-container {
  font-size: inherit;
  position: relative;
}
.orig-text-container {
  opacity: 0;
}
.clone-anim-container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.clone-container {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/NameContainer.vue